//src\http-image-common.js (frontend)

import axios from 'axios';

const apiClient = axios.create({
  // Comment out the production URLs
  //baseURL: 'https://media-device-stg-dot-bhmd-dev-app-navya.el.r.appspot.com/api/v1/admin',
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/v1/admin`,
  
  // Use local backend URL
  //baseURL: 'https://digitalsignage.digisamhita.com/api/v1/admin',
  headers: {
    'Content-type': 'multipart/form-data',
  }
});

apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

export default apiClient;

// import axios from 'axios';

// const apiClient = axios.create({
//   //baseURL: 'https://media-device-stg-dot-bhmd-dev-app-navya.el.r.appspot.com/api/v1/admin',
//   baseURL: 'https://digitalsignage.digisamhita.com/api/v1/admin',
//   headers: {
//     'Content-type': 'multipart/form-data',
//   }
// });

// apiClient.interceptors.request.use(config => {
//   const token = localStorage.getItem('token');
//   if (token) {
//     config.headers['Authorization'] = `Bearer ${token}`;
//   }
//   return config;
// }, error => {
//   return Promise.reject(error);
// });

// export default apiClient;